import { getUrlDefaults } from '~/src/Lib/Nav'

const urlDefaults = getUrlDefaults('rooms')
const urls = {
  ...urlDefaults,
  dashboard: urlDefaults.getUrl({ id: ':id', action: 'dashboard' }),
  inventory: urlDefaults.getUrl({ id: ':id', action: 'inventory' }),
}

export const isRoomDashboardRoute = ({ pattern }) => pattern === urls.view || pattern === urls.dashboard

export default urls
